import * as Yup from 'yup';
import { validatePhoneNumber } from 'utils/phoneHelpers';
Yup.addMethod(Yup.string, 'phone', function () {
  return this.test('phone', 'Phone number is not valid', (value) => {
    if (!value) return true;
    return validatePhoneNumber(value);
  });
});
